import React from "react"
import moment from "moment"
import { Box, Divider, Typography } from "@material-ui/core"
import { useSelector } from "react-redux"
import { useTheme, makeStyles } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
	cardHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginTop: "4px",
	},
	title: {
		color: theme.palette.grey.D100,
		fontWeight: 400,
	},
	reviewName: {
		fontWeight: 500,
	},
	dueDateMain: {
		display: "flex",
		alignItems: "center",
	},
	divider: {
		borderBottom: `1px solid ${theme.typography.button.disabledColor}`,
		margin: "24px 0px 15px 0px",
	},
}))

function UserReviewHeader(props) {
	const theme = useTheme()
	const classes = useStyles()
	const [t] = useTranslation("global")
	const selectedReview = useSelector((state) => state.dashboard?.selectedReview)

	return (
		<>
			<Divider className={classes.divider} variant="fullWidth" />
			<Box className={classes.cardHeader}>
				<Typography variant="subTitle2" className={classes.title}>
					{t("dashboard.userOverviewOnReview")} <span className={classes.reviewName}>{selectedReview?.name}</span>
				</Typography>
				{selectedReview?.due_date && (
					<Box className={classes.dueDateMain}>
						<Typography style={{ ...theme.typography.errorHelperLable, color: theme.palette.grey.D100, fontSize: 14 }}>
							{t("review.reviewForm.dueDate")}
						</Typography>
						<Typography
							style={{
								...theme.typography.errorHelperLable,
								color: theme.palette.status.failed,
								paddingLeft: 8,
								fontSize: 14,
							}}
						>
							{selectedReview?.due_date ? moment(selectedReview?.due_date).format("DD/MM/YYYY") : "-"}
						</Typography>
					</Box>
				)}
			</Box>
		</>
	)
}

export default UserReviewHeader
